import { useCallback, useEffect, useState } from 'react'
import { intl } from '../../../../../i18n'
import { useTeamRepository } from '../../../../../services/adaptors/teamRepositoryAdaptor'
import { CheckboxSelectConditionItemLabel } from '../CheckboxSelectConditionItemLabel'
import { useProjectPrivateContext } from '../../../../context/projectContext'
import { SelectOption } from '../../../../model/selectOption'

type TeamMultiAutocompleteConditionItemLabelProps = {
  value: string[] | undefined
  isLoading?: boolean
  onChange: (value: string[] | undefined) => void
  search: () => void
  onClose?: () => void
  teamOptions?: SelectOption[]
}

export const TeamMultiAutocompleteConditionItemLabel = ({
  value,
  isLoading,
  onChange,
  onClose,
  search,
  teamOptions: externalTeamOptions,
}: TeamMultiAutocompleteConditionItemLabelProps) => {
  const { projectUuid } = useProjectPrivateContext()
  const teamRepository = useTeamRepository()
  const [internalTeamOptions, setInternalTeamOptions] = useState<
    SelectOption[]
  >([])

  const fetchTeamOptions = useCallback(async () => {
    if (!projectUuid) return
    const teams = await teamRepository.fetchList(projectUuid)
    setInternalTeamOptions(
      teams.map(team => ({
        value: team.uuid,
        name: team.displayName,
        iconUrl: team.iconUrl,
      }))
    )
  }, [projectUuid, teamRepository])

  useEffect(() => {
    if (!externalTeamOptions) {
      fetchTeamOptions()
    }
  }, [fetchTeamOptions, externalTeamOptions])

  const teamOptions = externalTeamOptions ?? internalTeamOptions

  return (
    <CheckboxSelectConditionItemLabel
      header={intl.formatMessage({
        id: 'wbsItemSearchFilterPanel.team',
      })}
      value={value}
      onChange={onChange}
      onClose={onClose}
      search={search}
      options={teamOptions}
      isLoading={isLoading}
    />
  )
}
